<template>
  <div class="gold-img-block">
    <div class="gold-slider">
        <img :src="goldProductDescr.media_images" v-if="goldProductDescr.media_images" />
        <img src="../assets/images/thumbnail-default.jpg" v-else />
    </div>
    <div class="goldtitle-block">
      <h2>{{goldProductDescr.description}}</h2>
      <h6>
        {{$t('constructionfee')}}:
        <span class="rate">₹{{goldProductDescr.minting_cost}}</span>
        <!-- <span class="cross-rate">₹200</span> -->
      </h6>
    </div>
  </div>
</template>
<script>

import { mapGetters } from "vuex";
export default {
  components: {
  },
  props: {
    goldProductDescr: Object,
    require: true
  },
};
</script>